import { MessageStateType } from './Types';

export const messagesInitialState: MessageStateType = {
	action: false,
};
